import { useMemo } from 'react';
import { useIndustry } from '@/app/providers/industry-context.js';
import { assets } from '@/assets';
import groceryPlaceholder from '@/assets/grocery-product-placeholder.webp';
import { useCoffeePlaceholderSrc } from './coffeePlaceholder.js';

export function getThemePlaceholderSrc(industryKey, coffeePlaceholderSrc) {
  switch (industryKey) {
    case 'coffee':
      return coffeePlaceholderSrc;
    case 'fish':
      return '/fish-theme/fish-product-placeholder.png';
    case 'grocery':
      return groceryPlaceholder;
    case 'meat':
      return '/meat/product-meat.webp';
    case 'pet':
      return '/pet/pet-placeholder.png';
    case 'restaurant':
      return assets.restaurantDefaultImage;
    default:
      return '/base/placeholder.jpg';
  }
}

export function useThemePlaceholderSrc() {
  const { key: industryKey } = useIndustry();
  const coffeePlaceholderSrc = useCoffeePlaceholderSrc();

  return useMemo(
    () => getThemePlaceholderSrc(industryKey, coffeePlaceholderSrc),
    [industryKey, coffeePlaceholderSrc],
  );
}
